import { BILLION, MILLION, THOUSAND } from '@/constants';
import { isNumber } from '@/types';

export function numberFormat(locale = 'en-US') {
  return Intl.NumberFormat(locale).format;
}

export function currencyFormat(
  currency = 'USD',
  locale = 'en-US',
  style: 'long' | 'short' = 'long',
  minimumFractionDigits = 0,
  maximumFractionDigits = 2
) {
  function currencyFormatter(value: number):any {
    return value.toLocaleString('es-ES', {
      minimumFractionDigits: value % 1 === 0 ? 0 : 2,
      maximumFractionDigits: maximumFractionDigits,
      useGrouping: true,
    });
}

  return function (value?: number | null) {
    if (!isNumber(value)) {
      return null;
    }

    if (style === 'short') {
      if (value >= BILLION) {
        return `${currencyFormatter(value / BILLION)}B`;
      } else if (value >= MILLION) {
        return `${currencyFormatter(value / MILLION)}M`;
      } else if (value >= THOUSAND) {
        return `${currencyFormatter(value / THOUSAND)}K`;
      }
    }

    return currencyFormatter(value);
  };
}

export function niceMax(
  rawMax: number | null | undefined,
  opts: { targetTicks?: number; min?: number; paddingPct?: number } = {},
) {
  const { targetTicks = 6, min = 50, paddingPct = 0.1 } = opts;
  const x = Math.max(0, Number(rawMax ?? 0));
  const padded = x * (1 + paddingPct);
  if (padded === 0) return min;

  const rough = padded / Math.max(1, targetTicks);
  const pow10 = Math.pow(10, Math.floor(Math.log10(rough)));
  const steps = [1, 2, 5].map(s => s * pow10);
  const step = steps.find(s => rough <= s) ?? 10 * pow10;

  const upper = Math.ceil(padded / step) * step;
  return Math.max(min, upper);
}
